import { makeStyles } from '@material-ui/core/styles';
import { grey_dark } from '@theme/customTheme';

export const useStyles = makeStyles(theme => ({
  gridRoot: {
    flexGrow: 1,
  },
  gridTitle: {
    height: '100%',
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  helpIconBox: {
    cursor: 'pointer',
  },
  titleCompany: {
    fontFamily: 'Open Sans',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    color: grey_dark,
    marginLeft: '10px',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
      lineHeight: '16px',
      display: 'inline',
      width: '140px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  },
  sectionTitle: {
    lineHeight: '24px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    [theme.breakpoints.down('md')]: {
      lineHeight: '16px',
    },
  },
  gridContainerHeader: {
    position: 'relative',
  },
  gridBackBtn: {
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      top: '50%',
      left: '-16px',
      transform: 'translateY(-50%)',
    },
  },
  backBtn: {
    [theme.breakpoints.down('md')]: {
      width: '32px',
      height: '32px',
      borderRadius: '8px',
    },
  },
  ArrowLeftIcon: {
    [theme.breakpoints.down('md')]: {
      width: '16px',
      height: '16px',
      position: 'absolute',
    },
  },
  tooltipPaperText: {
    width: '250px',
    padding: '0px 10px',
    fontSize: '12px',
    lineHeight: '16px',
  },
  addNewButton: {
    backgroundColor: '#89CC21',
    color: '#FFFFFF',
    borderRadius: '16px',
    height: '56px',
    padding: '16px 24px',
  },
  blueBackBtn: {
    backgroundColor: '#0077D6 !important',
    '&:hover': {
      backgroundColor: '#0077D6 !important',
    },
  },
  blueColor: {
    color: '#0077D6 !important',
  },
}));
